import React, { useState } from "react";
import logoo from "../assets/logo.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

function Header({ onOpenAuth, onOpenMenu }) {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const initial = params.get("q") || "";
  const [value, setValue] = useState(initial);

  // UX: if user clears the search box on the search page, go back home immediately.
  React.useEffect(() => {
    if (pathname === "/search" && !value.trim()) navigate("/");
  }, [pathname, value, navigate]);

  function submitSearch(e) {
    e?.preventDefault();
    const q = value.trim();
    if (!q) {
      navigate("/");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(q)}`);
  }

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-8xl items-center justify-between px-6 py-3">
        <Link to="/" className="flex items-center gap-2">
          <img src={logoo} className="w-50 h-10" alt="logo" />
        </Link>

        <form
          onSubmit={submitSearch}
          className="hidden flex-1 items-center justify-center px-8 md:flex"
        >
          <div className="flex w-full max-w-xl items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-slate-500">
            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Paste a list or search (e.g., “Milk, Eggs, Bread”)..."
              className="w-full bg-transparent text-xs text-slate-700 focus:outline-none"
            />
            <button
              type="submit"
              className="rounded-full bg-indigo-600 px-4 py-1.5 text-xs font-semibold text-white"
            >
              Search
            </button>
          </div>
        </form>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onOpenMenu}
            aria-label="Open menu"
            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M4 7h16" />
              <path d="M4 12h16" />
              <path d="M4 17h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;